import parse, { domToReact } from 'html-react-parser';
import React from 'react';
import { parseLinkCallback } from '../../utils/LinkUtils';

const Lede = ({ richText }) => {
  return (
    <div className={`pagePadding pageGrid sectionVertPadding`}>
      <div className={`gridCenterContent textCenter`}>
        {parse(richText, {
          replace: (domNode) => {
            domNode = parseLinkCallback(domNode);
            if (domNode.name === 'p') {
              return <h1 className="h2">{domToReact(domNode.children)}</h1>;
            }
            return domNode;
          },
        })}
      </div>
    </div>
  );
};
export default Lede;
